import {NgModule} from "@angular/core";
import {IntDefaultPaginatorComponent} from "./int-default-paginator.component";
import {CommonModule} from "@angular/common";
import {IntDropdownAreaModule, IntTargetDropdownModule} from "../../dropdowns";
import {IntPortalSlotModule} from "../../../modules/portal-slot";
import {IntAttrBindingModule, IntInsertAfterViewInitModule} from "../../../directives";
import {IntIconModule} from "../../int-icon";
import {IntButtonModule} from "../../buttons/int-button";
import {IntDefaultInputModule} from "../../fields";
import {ReactiveFormsModule} from "@angular/forms";
import {IntEmptyDividerModule} from "../../dividers";
import {ScrollingModule} from "@angular/cdk/scrolling";

@NgModule({
  imports: [
    CommonModule,
    IntPortalSlotModule,
    IntInsertAfterViewInitModule,
    IntDropdownAreaModule,
    IntIconModule,
    IntButtonModule,
    IntTargetDropdownModule,
    IntDefaultInputModule,
    ReactiveFormsModule,
    IntEmptyDividerModule,
    IntAttrBindingModule,
    ScrollingModule
  ],
  declarations: [IntDefaultPaginatorComponent],
  exports: [IntDefaultPaginatorComponent]
})
export class IntDefaultPaginatorModule {}
